// Template data for Create by Lumera - 38 templates (15 free, 23 pro)
// useCase categories: marketing, business, education, lifestyle, fitness, creative

export const templates = [
  // ==================== FREE TEMPLATES ====================
  {
    id: 'effortless-quotes',
    name: 'Effortless Quotes',
    description: 'Minimal, elegant quote carousels that stop the scroll. Perfect for coaches, motivational content, and personal brands.',
    isPro: false,
    category: 'carousel',
    useCase: 'creative',
    badge: null,
    slides: 5,
    preview: 'https://static.prod-images.emergentagent.com/jobs/c37550dd-ae1c-4507-bee0-c7b9bef7e88a/images/d8b1b6842ecbfa8aa36a52527d0afa871436624fc89e76aa2a7557f1add7405f.png',
    previewColors: ['#F5F0EB', '#2C2C2C', '#C9A193'],
    preFill: {
      productType: 'carousel',
      tone: 'motivational',
      length: 'short',
      slideCount: 5,
      structure: [
        { type: 'hook', instruction: 'Opening quote that resonates deeply' },
        { type: 'content', instruction: 'Expand on the meaning behind the quote' },
        { type: 'content', instruction: 'Personal reflection or real-world example' },
        { type: 'content', instruction: 'Actionable takeaway from the message' },
        { type: 'cta', instruction: 'Save this for when you need a reminder' }
      ]
    }
  },
  {
    id: 'glow-up-before-after',
    name: 'Glow-Up Before & After',
    description: 'Transformation-focused template for beauty, fitness, lifestyle, or business results. Show the journey.',
    isPro: false,
    category: 'carousel',
    useCase: 'lifestyle',
    badge: null,
    slides: 6,
    preview: 'https://static.prod-images.emergentagent.com/jobs/c37550dd-ae1c-4507-bee0-c7b9bef7e88a/images/41ea75de9e8d73f22e14dcd36f784a2740845c3240b2b2bb5b91e44d36a614f2.png',
    previewColors: ['#FFF5F0', '#2C2C2C', '#E8B4A0'],
    preFill: {
      productType: 'carousel',
      tone: 'friendly',
      length: 'medium',
      slideCount: 6,
      structure: [
        { type: 'hook', instruction: 'Bold "Before vs After" hook that creates curiosity' },
        { type: 'content', instruction: 'The "before" state — the struggle, the problem' },
        { type: 'content', instruction: 'The turning point — what changed everything' },
        { type: 'content', instruction: 'The "after" state — the results, the transformation' },
        { type: 'content', instruction: 'Key steps or tips from the journey' },
        { type: 'cta', instruction: 'Want this transformation? Save + follow for more' }
      ]
    }
  },
  {
    id: 'quick-promo-boost',
    name: 'Quick Promo Boost',
    description: 'Clean, conversion-focused promo template. Perfect for product launches, offers, and announcements.',
    isPro: false,
    category: 'carousel',
    useCase: 'marketing',
    badge: null,
    slides: 5,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/68b33b18f8046a3788a375b5ebedbaba2b2c8cfd108933ab15831e504c413e07.png',
    previewColors: ['#FFF8F0', '#1A1A1A', '#C49A6C'],
    preFill: {
      productType: 'carousel',
      tone: 'professional',
      length: 'short',
      slideCount: 5,
      structure: [
        { type: 'hook', instruction: 'Attention-grabbing offer or announcement' },
        { type: 'content', instruction: 'What makes this product/offer special' },
        { type: 'content', instruction: 'Key benefits (bullet point style)' },
        { type: 'content', instruction: 'Social proof or testimonial' },
        { type: 'cta', instruction: 'Clear call-to-action with urgency' }
      ]
    }
  },
  {
    id: 'smart-tips-carousel',
    name: 'Smart Tips Carousel',
    description: 'Educational carousel template for sharing expert tips, how-tos, and valuable knowledge. Builds authority.',
    isPro: false,
    category: 'carousel',
    useCase: 'education',
    badge: null,
    slides: 7,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/ea80da75fc4b8b335582f525a7f7e073b7409f235fa9c1c267857b9e66160fa7.png',
    previewColors: ['#F0F5F0', '#2C2C2C', '#A3B18A'],
    preFill: {
      productType: 'carousel',
      tone: 'educational',
      length: 'medium',
      slideCount: 7,
      structure: [
        { type: 'hook', instruction: 'Number-based hook: "X tips that will change your..."' },
        { type: 'content', instruction: 'Tip 1 with brief explanation' },
        { type: 'content', instruction: 'Tip 2 with brief explanation' },
        { type: 'content', instruction: 'Tip 3 with brief explanation' },
        { type: 'content', instruction: 'Tip 4 with brief explanation' },
        { type: 'engagement', instruction: 'Which tip resonated most? Comment below!' },
        { type: 'cta', instruction: 'Save this for later & follow for more tips' }
      ]
    }
  },
  {
    id: 'client-love',
    name: 'Client Love (Testimonials)',
    description: 'Showcase your best reviews and client stories. Social proof that builds trust and drives sales.',
    isPro: false,
    category: 'carousel',
    useCase: 'marketing',
    badge: null,
    slides: 5,
    preview: 'https://static.prod-images.emergentagent.com/jobs/c37550dd-ae1c-4507-bee0-c7b9bef7e88a/images/fb802e3966760e4f1d2f7eeca5fafdb64dc634fa321c89ec6d7edaef78c26933.png',
    previewColors: ['#FFFCF9', '#292524', '#C9A193'],
    preFill: {
      productType: 'carousel',
      tone: 'friendly',
      length: 'medium',
      slideCount: 5,
      structure: [
        { type: 'hook', instruction: 'Opening: "What our clients are saying..."' },
        { type: 'content', instruction: 'Testimonial 1 with client name and result' },
        { type: 'content', instruction: 'Testimonial 2 with specific outcome' },
        { type: 'content', instruction: 'Testimonial 3 with emotional impact' },
        { type: 'cta', instruction: 'Ready for your own transformation? Link in bio' }
      ]
    }
  },
  {
    id: 'did-you-know',
    name: 'Did You Know?',
    description: 'Share surprising facts and insights that educate your audience and position you as an expert.',
    isPro: false,
    category: 'carousel',
    useCase: 'education',
    badge: null,
    slides: 6,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/6be8fe1a9ace332d3be64c8e8e55fb6ea3baaa354b4f4eaf4b905a12b4251ca0.png',
    previewColors: ['#F5F0EB', '#1A1A1A', '#8B7355'],
    preFill: {
      productType: 'carousel',
      tone: 'educational',
      length: 'medium',
      slideCount: 6,
      structure: [
        { type: 'hook', instruction: '"Did you know?" opening with a surprising fact' },
        { type: 'content', instruction: 'Fact 1 with context and explanation' },
        { type: 'content', instruction: 'Fact 2 — more surprising insight' },
        { type: 'content', instruction: 'Fact 3 — the most mind-blowing one' },
        { type: 'engagement', instruction: 'Which fact surprised you the most?' },
        { type: 'cta', instruction: 'Follow for more insights like this' }
      ]
    }
  },
  {
    id: 'daily-story-grwm',
    name: 'Daily Story / GRWM',
    description: 'Personal, relatable content that builds connection. GRWM, day-in-my-life, or personal story format.',
    isPro: false,
    category: 'carousel',
    useCase: 'creative',
    badge: null,
    slides: 6,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/af70c6ca0fba8dff3d4df7a3ad319be06b073270ff0d5beee9bd43b628bd0a9d.png',
    previewColors: ['#FFF5F5', '#2C2C2C', '#D4A0A0'],
    preFill: {
      productType: 'carousel',
      tone: 'casual',
      length: 'medium',
      slideCount: 6,
      structure: [
        { type: 'hook', instruction: 'Personal hook: "POV: you..." or "Story time..."' },
        { type: 'content', instruction: 'Set the scene — what happened, where you were' },
        { type: 'content', instruction: 'The middle — the challenge or funny moment' },
        { type: 'content', instruction: 'The lesson or takeaway' },
        { type: 'content', instruction: 'What you learned or how it changed you' },
        { type: 'cta', instruction: 'Can you relate? Share your story in the comments' }
      ]
    }
  },

  // ==================== PRO TEMPLATES (13) ====================
  {
    id: 'luxury-brand-story',
    name: 'Luxury Brand Story',
    description: 'Premium, high-end carousel with soft beige aesthetics. Perfect for luxury brands, jewelry, fashion, and premium services.',
    isPro: true,
    category: 'carousel',
    useCase: 'creative',
    badge: 'Most Popular',
    slides: 8,
    preview: 'https://static.prod-images.emergentagent.com/jobs/c37550dd-ae1c-4507-bee0-c7b9bef7e88a/images/2a6e37585a95c978aef3d1e2551941b72982b7041f177c9f60182f88aca2a60d.png',
    previewColors: ['#F5F0EB', '#2C2C2C', '#B8A089'],
    preFill: {
      productType: 'carousel',
      tone: 'luxury',
      length: 'long',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'Aspirational statement about luxury/quality' },
        { type: 'content', instruction: 'The story behind the brand — origins and vision' },
        { type: 'content', instruction: 'Craftsmanship and attention to detail' },
        { type: 'content', instruction: 'What makes this brand different' },
        { type: 'content', instruction: 'The experience of owning/using the product' },
        { type: 'content', instruction: 'Behind the scenes — the process' },
        { type: 'content', instruction: 'Client experience and exclusivity' },
        { type: 'cta', instruction: 'Experience the difference. Link in bio.' }
      ]
    }
  },
  {
    id: 'conversion-carousel',
    name: 'The Conversion Carousel',
    description: 'Data-driven, high-converting carousel built for sales. Problem → Agitate → Solve → CTA structure.',
    isPro: true,
    category: 'carousel',
    useCase: 'marketing',
    badge: 'Best Converting',
    slides: 8,
    preview: 'https://static.prod-images.emergentagent.com/jobs/c37550dd-ae1c-4507-bee0-c7b9bef7e88a/images/ac7613fc80dcda938692e0a3b8c03e0de7ec8379fb5b96c5cf11f25d68ce2f7f.png',
    previewColors: ['#FFFCF9', '#1A1A1A', '#C49A6C'],
    preFill: {
      productType: 'carousel',
      tone: 'professional',
      length: 'long',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: '"Why your [topic] isn\'t working..." — disruptive opener' },
        { type: 'content', instruction: 'The problem most people face (relatable pain)' },
        { type: 'content', instruction: 'Why the common advice doesn\'t work' },
        { type: 'content', instruction: 'The real solution (your unique approach)' },
        { type: 'content', instruction: 'Step 1 of the solution' },
        { type: 'content', instruction: 'Step 2 of the solution' },
        { type: 'content', instruction: 'Results and proof (numbers, testimonials)' },
        { type: 'cta', instruction: 'Ready to fix this? [Strong CTA with urgency]' }
      ]
    }
  },
  {
    id: 'viral-hook-machine',
    name: 'Viral Hook Machine',
    description: 'Attention-grabbing format inspired by top viral posts. Bold hooks that stop the scroll instantly.',
    isPro: true,
    category: 'carousel',
    useCase: 'marketing',
    badge: null,
    slides: 7,
    preview: 'https://static.prod-images.emergentagent.com/jobs/c37550dd-ae1c-4507-bee0-c7b9bef7e88a/images/935ad8fc4680033ec35af48251c44b8be9db50182eb0b6d668ea33e82792a347.png',
    previewColors: ['#F5F0EB', '#1A1A1A', '#2C2C2C'],
    preFill: {
      productType: 'carousel',
      tone: 'casual',
      length: 'medium',
      slideCount: 7,
      structure: [
        { type: 'hook', instruction: 'BOLD controversial or surprising statement' },
        { type: 'content', instruction: 'Why this matters more than you think' },
        { type: 'content', instruction: 'The truth nobody talks about' },
        { type: 'content', instruction: 'What to do instead (actionable)' },
        { type: 'content', instruction: 'Quick wins you can implement today' },
        { type: 'engagement', instruction: 'Agree or disagree? Drop your thoughts below' },
        { type: 'cta', instruction: 'Share this with someone who needs to hear it' }
      ]
    }
  },
  {
    id: 'problem-to-profit',
    name: 'Problem to Profit',
    description: 'Turn pain points into sales. Maps the customer journey from problem to your solution and offer.',
    isPro: true,
    category: 'carousel',
    useCase: 'marketing',
    badge: null,
    slides: 7,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/1d00e53a0a86bfe4ab384fb51add7029d45f15676102bac7e086d1ef5bff3a38.png',
    previewColors: ['#FFF8F0', '#292524', '#C49A6C'],
    preFill: {
      productType: 'carousel',
      tone: 'professional',
      length: 'medium',
      slideCount: 7,
      structure: [
        { type: 'hook', instruction: 'Describe a painful problem your audience faces' },
        { type: 'content', instruction: 'Agitate — make them feel the cost of inaction' },
        { type: 'content', instruction: 'Introduce the solution concept' },
        { type: 'content', instruction: 'Show how the solution works step by step' },
        { type: 'content', instruction: 'Present the results and transformation' },
        { type: 'content', instruction: 'Your specific offer and what\'s included' },
        { type: 'cta', instruction: 'Limited spots / special offer — act now' }
      ]
    }
  },
  {
    id: 'authority-builder',
    name: 'Authority Builder',
    description: 'Position yourself as the go-to expert. Expert tips format with credibility markers and proof.',
    isPro: true,
    category: 'carousel',
    useCase: 'business',
    badge: null,
    slides: 8,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/c30fb30572c6d4946230d113973bdc23587fde5fcf97fb48ff39d758a923b3cc.png',
    previewColors: ['#F5F5F0', '#1A1A1A', '#8B7355'],
    preFill: {
      productType: 'carousel',
      tone: 'professional',
      length: 'long',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: '"After [X years/clients], here\'s what I know..."' },
        { type: 'content', instruction: 'Expert insight #1 — the counterintuitive truth' },
        { type: 'content', instruction: 'Expert insight #2 — what most people get wrong' },
        { type: 'content', instruction: 'Expert insight #3 — the simple fix' },
        { type: 'content', instruction: 'Expert insight #4 — advanced strategy' },
        { type: 'content', instruction: 'Expert insight #5 — the game changer' },
        { type: 'engagement', instruction: 'Which insight was most valuable? Save for later' },
        { type: 'cta', instruction: 'Follow for more expert insights daily' }
      ]
    }
  },
  {
    id: 'stop-doing-this',
    name: 'The "Stop Doing This" Post',
    description: 'Contrarian content that challenges bad habits. High engagement and shareability built in.',
    isPro: true,
    category: 'carousel',
    useCase: 'marketing',
    badge: null,
    slides: 7,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/1df5a950d3a49d04645896c321fdccc8fb5e868dc2c3ae975d56fcf2383d1765.png',
    previewColors: ['#FFFCF9', '#1A1A1A', '#C49A6C'],
    preFill: {
      productType: 'carousel',
      tone: 'casual',
      length: 'medium',
      slideCount: 7,
      structure: [
        { type: 'hook', instruction: '"Stop doing [common mistake] if you want [result]"' },
        { type: 'content', instruction: 'Mistake #1 — what it is and why it hurts' },
        { type: 'content', instruction: 'Mistake #2 — the hidden cost' },
        { type: 'content', instruction: 'Mistake #3 — the biggest one nobody talks about' },
        { type: 'content', instruction: 'What to do INSTEAD (the better approach)' },
        { type: 'engagement', instruction: 'Which mistake were you making? Be honest!' },
        { type: 'cta', instruction: 'Save this as a reminder & share with a friend' }
      ]
    }
  },
  {
    id: 'magnetic-personal-brand',
    name: 'Magnetic Personal Brand',
    description: 'Build a personal brand that attracts. Introduce yourself, share your story, and connect with your ideal audience.',
    isPro: true,
    category: 'carousel',
    useCase: 'creative',
    badge: null,
    slides: 8,
    preview: 'https://static.prod-images.emergentagent.com/jobs/c37550dd-ae1c-4507-bee0-c7b9bef7e88a/images/c80d1643da9a00f131b3187389a5c011d6e69398fb3db33047d3d1b8b99df1c4.png',
    previewColors: ['#F5F0EB', '#2C2C2C', '#C9A193'],
    preFill: {
      productType: 'carousel',
      tone: 'friendly',
      length: 'long',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: '"Meet the person behind the brand..."' },
        { type: 'content', instruction: 'Your origin story — why you started' },
        { type: 'content', instruction: 'The struggle — what you overcame' },
        { type: 'content', instruction: 'Your mission — what drives you' },
        { type: 'content', instruction: 'What you help people achieve' },
        { type: 'content', instruction: 'Your unique approach or method' },
        { type: 'content', instruction: 'Fun facts about you (relatable human side)' },
        { type: 'cta', instruction: 'Follow along for the journey. Let\'s connect!' }
      ]
    }
  },
  {
    id: 'top-5-secrets',
    name: 'Top 5 Secrets',
    description: 'Listicle-style carousel perfect for sharing ranked tips, secrets, or recommendations. High save rate.',
    isPro: true,
    category: 'carousel',
    useCase: 'education',
    badge: null,
    slides: 7,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/d320349eef2280047bb034407072e586daa60234b31bcc04636856678a1219f6.png',
    previewColors: ['#F0F0EB', '#1A1A1A', '#A3B18A'],
    preFill: {
      productType: 'carousel',
      tone: 'educational',
      length: 'medium',
      slideCount: 7,
      structure: [
        { type: 'hook', instruction: '"Top 5 secrets to [desirable outcome]"' },
        { type: 'content', instruction: 'Secret #5 (start with good, build to great)' },
        { type: 'content', instruction: 'Secret #4' },
        { type: 'content', instruction: 'Secret #3' },
        { type: 'content', instruction: 'Secret #2' },
        { type: 'content', instruction: 'Secret #1 — THE game changer' },
        { type: 'cta', instruction: 'Save this list & share with someone who needs it' }
      ]
    }
  },
  {
    id: 'glow-up-story',
    name: 'The Glow-Up Story',
    description: 'Share a complete transformation narrative. Before, during, and after — with emotional resonance.',
    isPro: true,
    category: 'carousel',
    useCase: 'creative',
    badge: null,
    slides: 8,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/2b985f22d999c987bbf958fea3fd707b1e4c2db77e4efc3b62bd3a93c24067f0.png',
    previewColors: ['#FFF5F0', '#2C2C2C', '#D4A0A0'],
    preFill: {
      productType: 'carousel',
      tone: 'motivational',
      length: 'long',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: '"This is my glow-up story..." — vulnerable opener' },
        { type: 'content', instruction: 'Where it all started — the rock bottom' },
        { type: 'content', instruction: 'The moment everything changed' },
        { type: 'content', instruction: 'The work that went into the transformation' },
        { type: 'content', instruction: 'The setbacks along the way' },
        { type: 'content', instruction: 'Where I am now — the results' },
        { type: 'content', instruction: 'What I wish I knew at the beginning' },
        { type: 'cta', instruction: 'Your glow-up is coming. Save this for motivation' }
      ]
    }
  },
  {
    id: 'launch-like-a-pro',
    name: 'Launch Like a Pro',
    description: 'Product launch or drop announcement template. Build hype, create urgency, and drive sales.',
    isPro: true,
    category: 'carousel',
    useCase: 'marketing',
    badge: 'Best for Sales',
    slides: 8,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/d3f0ca1d487b7c07889f02676f895d88c241aa0d6fab3a8fa1435fe323a1c057.png',
    previewColors: ['#1A1A1A', '#FFFCF9', '#C49A6C'],
    preFill: {
      productType: 'carousel',
      tone: 'luxury',
      length: 'long',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'Teaser: "Something new is coming..."' },
        { type: 'content', instruction: 'The problem this product solves' },
        { type: 'content', instruction: 'What makes this different from everything else' },
        { type: 'content', instruction: 'Feature highlight #1' },
        { type: 'content', instruction: 'Feature highlight #2' },
        { type: 'content', instruction: 'Social proof — early reviews or waitlist numbers' },
        { type: 'content', instruction: 'The offer — pricing, bonuses, limited quantity' },
        { type: 'cta', instruction: 'Launch day special — grab yours before it sells out' }
      ]
    }
  },
  {
    id: 'pinterest-traffic-booster',
    name: 'Pinterest Traffic Booster',
    description: 'Tall-format pin designed for maximum Pinterest reach. Drive traffic to your shop or blog.',
    isPro: true,
    category: 'pin',
    useCase: 'marketing',
    badge: null,
    slides: 1,
    preview: 'https://static.prod-images.emergentagent.com/jobs/c37550dd-ae1c-4507-bee0-c7b9bef7e88a/images/19d3f172fd233bb8f31dbd89e17db93841a5ebba6d7675a58025481fc2be2c64.png',
    previewColors: ['#F5F0EB', '#2C2C2C', '#C9A193'],
    preFill: {
      productType: 'carousel',
      tone: 'professional',
      length: 'short',
      slideCount: 5,
      structure: [
        { type: 'hook', instruction: 'Eye-catching headline with keyword-rich title' },
        { type: 'content', instruction: 'Key benefit or value proposition' },
        { type: 'content', instruction: 'Supporting details or quick tips' },
        { type: 'content', instruction: 'Visual call-out or stat' },
        { type: 'cta', instruction: 'Click to read more / Shop now / Get the guide' }
      ]
    }
  },
  {
    id: 'lead-magnet-magnet',
    name: 'Lead Magnet Magnet',
    description: 'Promote your freebie, lead magnet, or opt-in offer. Designed to maximize email signups.',
    isPro: true,
    category: 'carousel',
    useCase: 'marketing',
    badge: null,
    slides: 6,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/1bd958ee757e7d11b5da0cee88bf6060bf8466a9509fbd69bc31ef97b0cd94f6.png',
    previewColors: ['#FFF8F0', '#292524', '#A3B18A'],
    preFill: {
      productType: 'carousel',
      tone: 'friendly',
      length: 'medium',
      slideCount: 6,
      structure: [
        { type: 'hook', instruction: '"FREE: [Name of your lead magnet]"' },
        { type: 'content', instruction: 'What\'s inside the freebie (preview)' },
        { type: 'content', instruction: 'Who this is perfect for' },
        { type: 'content', instruction: 'What you\'ll learn or achieve' },
        { type: 'content', instruction: 'Testimonial from someone who used it' },
        { type: 'cta', instruction: 'Grab your free copy — link in bio' }
      ]
    }
  },
  {
    id: 'high-ticket-sales-flow',
    name: 'High-Ticket Sales Flow',
    description: 'Premium sales funnel carousel for coaching, courses, and high-value offers. Built to qualify and convert.',
    isPro: true,
    category: 'carousel',
    useCase: 'business',
    badge: 'Premium',
    slides: 10,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/5a8afe1240a30be9cec88df13585375e8cbf5d7c1c7ce1236817d0bcf6933a1e.png',
    previewColors: ['#1A1A1A', '#F5F0EB', '#C9A193'],
    preFill: {
      productType: 'carousel',
      tone: 'luxury',
      length: 'long',
      slideCount: 10,
      structure: [
        { type: 'hook', instruction: 'Bold statement about high-value results' },
        { type: 'content', instruction: 'The cost of staying where you are' },
        { type: 'content', instruction: 'Why most solutions don\'t work' },
        { type: 'content', instruction: 'Your unique methodology or framework' },
        { type: 'content', instruction: 'Pillar 1 of your approach' },
        { type: 'content', instruction: 'Pillar 2 of your approach' },
        { type: 'content', instruction: 'Pillar 3 of your approach' },
        { type: 'content', instruction: 'Results and case studies' },
        { type: 'content', instruction: 'What\'s included in the offer' },
        { type: 'cta', instruction: 'Apply now — limited spots available' }
      ]
    }
  },

  /* ───────────────────── NEW FREE TEMPLATES ───────────────────── */
  {
    id: 'minimalist-lifestyle',
    name: 'Minimalist Lifestyle Guide',
    description: 'Clean, airy template for minimalism, decluttering, and intentional living guides.',
    slides: 8,
    isPro: false,
    category: 'guide',
    useCase: 'lifestyle',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/fb1eedd80ff41a5189fbf105e422aae690d92714143317d2101bb7f9fd536eeb.png',
    previewColors: ['#FAFAFA', '#1A1A1A', '#9CA3AF'],
    preFill: {
      productType: 'guide',
      tone: 'casual',
      length: 'medium',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'Open with a question: "What if less really is more?"' },
        { type: 'content', instruction: 'Define the lifestyle philosophy in one sentence' },
        { type: 'content', instruction: 'Step 1: Start with your physical space' },
        { type: 'content', instruction: 'Step 2: Simplify your digital life' },
        { type: 'content', instruction: 'Step 3: Reduce decision fatigue' },
        { type: 'content', instruction: 'Step 4: Mindful consumption habits' },
        { type: 'engagement', instruction: 'Share a before/after scenario' },
        { type: 'cta', instruction: 'Challenge: Try 1 thing today' }
      ]
    }
  },
  {
    id: 'recipe-collection',
    name: 'Recipe Collection',
    description: 'Warm, inviting template for cookbooks, meal guides, and recipe e-books.',
    slides: 10,
    isPro: false,
    category: 'guide',
    useCase: 'lifestyle',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/895d2a6e2310c69762b12a45ff961b3c1e8cf3e7e8d5abf6227cf7896372a5ee.png',
    previewColors: ['#FFF8F0', '#3D2B1F', '#E8965A'],
    preFill: {
      productType: 'guide',
      tone: 'friendly',
      length: 'long',
      slideCount: 10,
      structure: [
        { type: 'hook', instruction: 'Mouth-watering title: "[Number] Recipes That..."' },
        { type: 'content', instruction: 'Recipe 1: Ingredients + simple directions' },
        { type: 'content', instruction: 'Recipe 2: Quick weeknight meal' },
        { type: 'content', instruction: 'Recipe 3: Crowd-pleaser for gatherings' },
        { type: 'content', instruction: 'Recipe 4: Healthy option' },
        { type: 'content', instruction: 'Recipe 5: Comfort food classic' },
        { type: 'content', instruction: 'Meal prep tips and storage advice' },
        { type: 'content', instruction: 'Shopping list template' },
        { type: 'engagement', instruction: 'Which recipe will you try first? Tag us!' },
        { type: 'cta', instruction: 'Get the full collection — link in bio' }
      ]
    }
  },
  {
    id: 'travel-planner',
    name: 'Travel Planner',
    description: 'Adventure-ready template for trip planning, packing lists, and travel journals.',
    slides: 8,
    isPro: false,
    category: 'planner',
    useCase: 'lifestyle',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/f43b6cade2a982348916f2acc0994abf658a335f30aa8380c0c9797dfd7b3a4c.png',
    previewColors: ['#F0F7F7', '#1A3A3A', '#4AADA0'],
    preFill: {
      productType: 'daily-planner',
      tone: 'friendly',
      length: 'medium',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'Wanderlust opener: "Your next adventure starts here"' },
        { type: 'content', instruction: 'Trip overview: destination, dates, budget' },
        { type: 'content', instruction: 'Day-by-day itinerary planner' },
        { type: 'content', instruction: 'Packing checklist by category' },
        { type: 'content', instruction: 'Budget tracker: flights, hotels, food, activities' },
        { type: 'content', instruction: 'Restaurant and activity wishlist' },
        { type: 'content', instruction: 'Emergency contacts and documents checklist' },
        { type: 'cta', instruction: 'Travel memories and notes page' }
      ]
    }
  },
  {
    id: 'study-notes',
    name: 'Study Notes & Cheat Sheet',
    description: 'Academic-style template for study guides, exam prep, and educational cheat sheets.',
    slides: 7,
    isPro: false,
    category: 'education',
    useCase: 'education',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/04ca5c4fe9bc7c9f392db94c1cb7eee4032fe7ba6bea3fdbbad3ca05b29ccde5.png',
    previewColors: ['#F0F4F8', '#1A2A40', '#F5C542'],
    preFill: {
      productType: 'guide',
      tone: 'educational',
      length: 'medium',
      slideCount: 7,
      structure: [
        { type: 'hook', instruction: 'Topic title with "Everything you need to know about..."' },
        { type: 'content', instruction: 'Key concept 1: Definition and explanation' },
        { type: 'content', instruction: 'Key concept 2: With a simple example' },
        { type: 'content', instruction: 'Key concept 3: Common mistakes to avoid' },
        { type: 'content', instruction: 'Quick reference table or formula sheet' },
        { type: 'content', instruction: 'Practice questions or flashcard prompts' },
        { type: 'cta', instruction: 'Save this for exam day!' }
      ]
    }
  },
  {
    id: 'wedding-planner',
    name: 'Wedding Planning Checklist',
    description: 'Elegant template for wedding timelines, vendor checklists, and ceremony planners.',
    slides: 10,
    isPro: false,
    category: 'planner',
    useCase: 'lifestyle',
    badge: 'Popular',
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/650f3223e1a73f7cf6c917eecc8a87af20b6fb14fd0420ba1282b4f52235a6b2.png',
    previewColors: ['#FFF5F5', '#3D2020', '#D4A0A0'],
    preFill: {
      productType: 'goal-workbook',
      tone: 'luxury',
      length: 'long',
      slideCount: 10,
      structure: [
        { type: 'hook', instruction: 'Romantic opener: "Your dream wedding starts here"' },
        { type: 'content', instruction: '12-month countdown timeline' },
        { type: 'content', instruction: 'Budget planner with categories' },
        { type: 'content', instruction: 'Venue comparison checklist' },
        { type: 'content', instruction: 'Vendor contact tracker' },
        { type: 'content', instruction: 'Guest list organizer' },
        { type: 'content', instruction: 'Menu and catering planner' },
        { type: 'content', instruction: 'Day-of timeline (hour by hour)' },
        { type: 'content', instruction: 'Emergency kit checklist' },
        { type: 'cta', instruction: 'Notes and special moments to remember' }
      ]
    }
  },
  {
    id: 'morning-routine',
    name: 'Morning Routine Blueprint',
    description: 'Energizing template for morning routines, daily rituals, and productivity systems.',
    slides: 7,
    isPro: false,
    category: 'lifestyle',
    useCase: 'lifestyle',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/b90304ee2fe62059df0d897aa9ef8440c91fa4a8e023fc1a5076953c07bc3200.png',
    previewColors: ['#FFF8F0', '#2C1A0E', '#E8854A'],
    preFill: {
      productType: 'habit-tracker',
      tone: 'motivational',
      length: 'medium',
      slideCount: 7,
      structure: [
        { type: 'hook', instruction: '"Win your morning, win your day" — transformative opener' },
        { type: 'content', instruction: 'The science behind morning routines' },
        { type: 'content', instruction: 'Step 1: Wake-up ritual (first 15 minutes)' },
        { type: 'content', instruction: 'Step 2: Movement and energy' },
        { type: 'content', instruction: 'Step 3: Mindset and intention setting' },
        { type: 'content', instruction: 'Step 4: Planning and priorities' },
        { type: 'cta', instruction: '30-day morning routine tracker' }
      ]
    }
  },
  {
    id: 'gratitude-journal',
    name: 'Digital Gratitude Journal',
    description: 'Calming template for gratitude logs, mindfulness journals, and self-reflection workbooks.',
    slides: 8,
    isPro: false,
    category: 'lifestyle',
    useCase: 'lifestyle',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/2992ca72fda05ebf2befa2fcd087c4f651a99dfc2cb760096ff4cecc4ba71995.png',
    previewColors: ['#F5F0F8', '#2A1A3A', '#9B7EBD'],
    preFill: {
      productType: 'goal-workbook',
      tone: 'friendly',
      length: 'medium',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: '"Start each day with gratitude" — mindful introduction' },
        { type: 'content', instruction: 'How gratitude rewires your brain (the science)' },
        { type: 'content', instruction: 'Daily gratitude prompt template' },
        { type: 'content', instruction: 'Weekly reflection questions' },
        { type: 'content', instruction: 'Monthly highlights and celebrations' },
        { type: 'content', instruction: 'Gratitude letter template (to someone special)' },
        { type: 'engagement', instruction: 'Affirmations and positive reminders' },
        { type: 'cta', instruction: '30-day gratitude challenge tracker' }
      ]
    }
  },
  {
    id: 'fitness-challenge',
    name: 'Fitness Challenge Tracker',
    description: 'High-energy template for workout challenges, fitness programs, and body transformation plans.',
    slides: 8,
    isPro: false,
    category: 'fitness',
    useCase: 'fitness',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/46f9409671496f4ac2fcde15a255c779552ab30a80e5f9e98fc4637c24cb61a5.png',
    previewColors: ['#1A1A1A', '#F0F0F0', '#4ADE80'],
    preFill: {
      productType: 'workout-planner',
      tone: 'motivational',
      length: 'medium',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'Bold challenge announcement: "30 Days to a Stronger You"' },
        { type: 'content', instruction: 'Week 1: Foundation exercises (beginner-friendly)' },
        { type: 'content', instruction: 'Week 2: Increase intensity' },
        { type: 'content', instruction: 'Week 3: Push through the plateau' },
        { type: 'content', instruction: 'Week 4: Final push and results' },
        { type: 'content', instruction: 'Daily workout log template' },
        { type: 'content', instruction: 'Nutrition tips for maximum results' },
        { type: 'cta', instruction: 'Progress tracker: measurements and photos' }
      ]
    }
  },

  /* ───────────────────── NEW PREMIUM TEMPLATES ───────────────────── */
  {
    id: 'ceo-mindset',
    name: 'CEO Mindset Manifesto',
    description: 'Powerful leadership template for mindset content, success principles, and entrepreneurial wisdom.',
    slides: 8,
    isPro: true,
    category: 'business',
    useCase: 'business',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/b8c8f00f8690b55cc625f8a488a46e41160dcc2587de0bd135f3af3b5dec71d1.png',
    previewColors: ['#0F1629', '#F0E6D0', '#D4A854'],
    preFill: {
      productType: 'carousel',
      tone: 'motivational',
      length: 'medium',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'Power statement: "The mindset that built empires"' },
        { type: 'content', instruction: 'Principle 1: Think in systems, not tasks' },
        { type: 'content', instruction: 'Principle 2: Invest in yourself first' },
        { type: 'content', instruction: 'Principle 3: Embrace strategic risk' },
        { type: 'content', instruction: 'Principle 4: Build for leverage, not labor' },
        { type: 'content', instruction: 'Principle 5: Guard your energy ruthlessly' },
        { type: 'engagement', instruction: 'Which principle resonates most? Comment below' },
        { type: 'cta', instruction: 'Follow for daily CEO mindset drops' }
      ]
    }
  },
  {
    id: 'client-onboarding',
    name: 'Client Onboarding Toolkit',
    description: 'Professional template for welcome kits, onboarding guides, and client workflow documents.',
    slides: 9,
    isPro: true,
    category: 'business',
    useCase: 'business',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/a37d4ce51c5dccbb81206c675f364a238e4828453cbb0b5765cf3309f4998821.png',
    previewColors: ['#F0F7F7', '#1A3030', '#2AADA0'],
    preFill: {
      productType: 'guide',
      tone: 'professional',
      length: 'long',
      slideCount: 9,
      structure: [
        { type: 'hook', instruction: 'Warm welcome message with brand introduction' },
        { type: 'content', instruction: 'What to expect: Overview of the process' },
        { type: 'content', instruction: 'Step 1: Getting started checklist' },
        { type: 'content', instruction: 'Step 2: Key contacts and communication channels' },
        { type: 'content', instruction: 'Step 3: Important dates and milestones' },
        { type: 'content', instruction: 'FAQ: Common questions answered' },
        { type: 'content', instruction: 'Resources and helpful links' },
        { type: 'content', instruction: 'Feedback and review process' },
        { type: 'cta', instruction: 'Next steps and action items' }
      ]
    }
  },
  {
    id: 'content-calendar',
    name: 'Social Media Content Calendar',
    description: 'Organized template for planning social media content, posting schedules, and content strategies.',
    slides: 8,
    isPro: true,
    category: 'business',
    useCase: 'business',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/488244a403bde1e8cec9b7835aedd1d33b64596b5ffe9ae5a58d9136e502079f.png',
    previewColors: ['#F8F0FF', '#1A1030', '#A855F7'],
    preFill: {
      productType: 'business-planner',
      tone: 'professional',
      length: 'medium',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'Month overview: Goals and themes' },
        { type: 'content', instruction: 'Week 1: Content pillars and topics' },
        { type: 'content', instruction: 'Week 2: Engagement-focused content' },
        { type: 'content', instruction: 'Week 3: Sales and promotion content' },
        { type: 'content', instruction: 'Week 4: Community and personal content' },
        { type: 'content', instruction: 'Hashtag strategy by content type' },
        { type: 'content', instruction: 'Analytics tracker: What to measure' },
        { type: 'cta', instruction: 'Content idea bank and brainstorm page' }
      ]
    }
  },
  {
    id: 'viral-hook',
    name: 'The Viral Hook Formula',
    description: 'Attention-grabbing template for creating viral content, scroll-stopping hooks, and engagement magnets.',
    slides: 8,
    isPro: true,
    category: 'marketing',
    useCase: 'marketing',
    badge: 'Trending',
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/2069f7634e544857d4aff8d00b1eae0f3e4cc0a687ab0d2364fff975044b2edd.png',
    previewColors: ['#1A1A1A', '#F0F0F0', '#E4FF1A'],
    preFill: {
      productType: 'carousel',
      tone: 'casual',
      length: 'medium',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'The "Wait, what?" opener that stops thumbs' },
        { type: 'content', instruction: 'Hook type 1: The controversial opinion' },
        { type: 'content', instruction: 'Hook type 2: The "Nobody talks about this"' },
        { type: 'content', instruction: 'Hook type 3: The relatable confession' },
        { type: 'content', instruction: 'Hook type 4: The surprising statistic' },
        { type: 'content', instruction: 'The formula: Hook + Value + CTA' },
        { type: 'engagement', instruction: 'Try it: Write your hook in the comments' },
        { type: 'cta', instruction: 'Save this for your next post!' }
      ]
    }
  },
  {
    id: 'ecommerce-showcase',
    name: 'E-Commerce Product Showcase',
    description: 'Elegant template for product launches, collection reveals, and online store highlights.',
    slides: 8,
    isPro: true,
    category: 'marketing',
    useCase: 'marketing',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/7a6b1c18bed7b2a4ea30615bdcc401c274a7cce13b6b64da960b921249b6e440.png',
    previewColors: ['#FFFAF5', '#1A1A1A', '#C9857A'],
    preFill: {
      productType: 'carousel',
      tone: 'luxury',
      length: 'medium',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'Product reveal: "Introducing [product name]"' },
        { type: 'content', instruction: 'Hero feature: The #1 benefit' },
        { type: 'content', instruction: 'Key feature 2: What makes it different' },
        { type: 'content', instruction: 'Key feature 3: The quality details' },
        { type: 'content', instruction: 'Social proof: Reviews and ratings' },
        { type: 'content', instruction: 'How to use / style it' },
        { type: 'content', instruction: 'Pricing and bundle options' },
        { type: 'cta', instruction: 'Shop now — limited stock available' }
      ]
    }
  },
  {
    id: 'course-launch',
    name: 'Course Launch Blueprint',
    description: 'Strategic template for online course launches, webinar funnels, and educational program promotions.',
    slides: 9,
    isPro: true,
    category: 'education',
    useCase: 'education',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/08a863547531d951b39cb71dfd2a73a5f6e36016d179dacd920b8098353aa5f1.png',
    previewColors: ['#F0F0F8', '#1A1A3A', '#E86C40'],
    preFill: {
      productType: 'guide',
      tone: 'professional',
      length: 'long',
      slideCount: 9,
      structure: [
        { type: 'hook', instruction: 'Big promise: "Learn [skill] in [timeframe]"' },
        { type: 'content', instruction: 'The problem: Why most people struggle with this' },
        { type: 'content', instruction: 'Modulee 1: Foundation and basics' },
        { type: 'content', instruction: 'Modulee 2: Advanced strategies' },
        { type: 'content', instruction: 'Modulee 3: Implementation and practice' },
        { type: 'content', instruction: 'Student results and transformations' },
        { type: 'content', instruction: 'What\'s included: Full course breakdown' },
        { type: 'content', instruction: 'Bonuses and extras' },
        { type: 'cta', instruction: 'Enroll now — early bird pricing ends soon' }
      ]
    }
  },
  {
    id: 'personal-brand',
    name: 'Personal Brand Kit',
    description: 'Creative template for building your personal brand identity, bio, and visual guidelines.',
    slides: 8,
    isPro: true,
    category: 'creative',
    useCase: 'creative',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/3987b787b63e58e0b3a0c4fb9fba8c75a8a7c441d3f487288426f3188da3efac.png',
    previewColors: ['#F5EDE0', '#2A1A0A', '#C48650'],
    preFill: {
      productType: 'guide',
      tone: 'professional',
      length: 'medium',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'Introduction: "Build a brand that\'s unmistakably you"' },
        { type: 'content', instruction: 'Your brand mission and values' },
        { type: 'content', instruction: 'Target audience avatar' },
        { type: 'content', instruction: 'Visual identity: Colors, fonts, and style' },
        { type: 'content', instruction: 'Brand voice and messaging guidelines' },
        { type: 'content', instruction: 'Content pillars: What you talk about' },
        { type: 'content', instruction: 'Bio templates for every platform' },
        { type: 'cta', instruction: 'Action plan: Launch your brand in 7 days' }
      ]
    }
  },
  {
    id: 'real-estate',
    name: 'Real Estate Listing Showcase',
    description: 'Elegant template for property listings, open house promotions, and real estate marketing.',
    slides: 8,
    isPro: true,
    category: 'business',
    useCase: 'business',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/dbcd72306c187c8f2cb8ff1ad6769409242f8b6fd8b5039eb44afaf9a904d99a.png',
    previewColors: ['#F0F5F0', '#1A2A1A', '#2A6A40'],
    preFill: {
      productType: 'carousel',
      tone: 'luxury',
      length: 'medium',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'Stunning property reveal: "Welcome to your dream home"' },
        { type: 'content', instruction: 'Property highlights: Bedrooms, baths, sqft' },
        { type: 'content', instruction: 'Kitchen and living areas features' },
        { type: 'content', instruction: 'Outdoor space and neighborhood' },
        { type: 'content', instruction: 'Smart home and premium features' },
        { type: 'content', instruction: 'Location benefits and nearby amenities' },
        { type: 'content', instruction: 'Pricing and financing options' },
        { type: 'cta', instruction: 'Schedule a private showing today' }
      ]
    }
  },
  {
    id: 'coaching-program',
    name: 'Coaching Program Outline',
    description: 'Transformative template for coaching offers, program outlines, and client transformation journeys.',
    slides: 9,
    isPro: true,
    category: 'business',
    useCase: 'business',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/cdeb65d0866ce070a6b87ff758a515084afb7fec0949399967ee19b5b77bae3e.png',
    previewColors: ['#F5F0FA', '#1A102A', '#7C3AED'],
    preFill: {
      productType: 'guide',
      tone: 'motivational',
      length: 'long',
      slideCount: 9,
      structure: [
        { type: 'hook', instruction: 'Transformation promise: "From [current state] to [desired state]"' },
        { type: 'content', instruction: 'Who this program is for' },
        { type: 'content', instruction: 'Phase 1: Discovery and assessment' },
        { type: 'content', instruction: 'Phase 2: Strategy and planning' },
        { type: 'content', instruction: 'Phase 3: Implementation and accountability' },
        { type: 'content', instruction: 'Phase 4: Review and next level' },
        { type: 'content', instruction: 'Client success stories' },
        { type: 'content', instruction: 'What\'s included: Sessions, tools, support' },
        { type: 'cta', instruction: 'Book your discovery call — limited spots' }
      ]
    }
  },
  {
    id: 'storytelling-framework',
    name: 'The Storytelling Framework',
    description: 'Narrative-driven template for brand stories, personal journeys, and connection-building content.',
    slides: 8,
    isPro: true,
    category: 'creative',
    useCase: 'creative',
    badge: null,
    preview: 'https://static.prod-images.emergentagent.com/jobs/75840371-280e-4d62-89cc-6d1431e5d99f/images/cfe1e047dad6ff7f1051eea0732dfd6dd6226eb4697a1e6736fae227f9b85b0e.png',
    previewColors: ['#F5F0E5', '#2A1A0A', '#8B6914'],
    preFill: {
      productType: 'carousel',
      tone: 'casual',
      length: 'medium',
      slideCount: 8,
      structure: [
        { type: 'hook', instruction: 'Open with a vivid scene: "I was sitting in my car, crying..."' },
        { type: 'content', instruction: 'The context: Where you were before' },
        { type: 'content', instruction: 'The turning point: What changed everything' },
        { type: 'content', instruction: 'The struggle: What you had to overcome' },
        { type: 'content', instruction: 'The breakthrough: The moment of clarity' },
        { type: 'content', instruction: 'The lesson: What you learned' },
        { type: 'engagement', instruction: 'Share your story: Ask the audience to relate' },
        { type: 'cta', instruction: 'Follow for more real stories' }
      ]
    }
  }
];

export const getTemplateById = (id) => templates.find(t => t.id === id);
export const getFreeTemplates = () => templates.filter(t => !t.isPro);
export const getProTemplates = () => templates.filter(t => t.isPro);
